var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", {}, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "full-page",
          class: _vm.pageClass,
          attrs: { "data-color": _vm.backgroundColor }
        },
        [
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "container" }, [_vm._t("default")], 2)
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "full-page-background",
            staticStyle: {
              "background-image": "url(static/img/full-screen-image-1.jpg)"
            }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "nav",
      {
        staticClass:
          "navbar navbar-expand-lg navbar-transparent navbar-absolute"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "navbar-wrapper" }, [
            _vm._v("\n           \n        ")
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24ab8d9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24ab8d9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Auth/AuthLayout.vue
// module id = dRxv
// module chunks = 4